import { render } from "./BankInfo.vue?vue&type=template&id=24cc0d06&scoped=true"
import script from "./BankInfo.vue?vue&type=script&lang=js"
export * from "./BankInfo.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-24cc0d06"

export default script